import classNames from "classnames";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Fade } from "../../animation/animation";
import styles from "./popup-window.module.scss";
import { useSize } from "../../common-effects";
import { setPopupWidth } from "../../reducers/quiz/quiz.actions";

interface PopupWindowProps {
  active: boolean;
  onClose?: () => void;
  showCloseButton?: boolean;
}

export function PopupWindow(props: React.PropsWithChildren<PopupWindowProps>) {
  const { children, onClose, showCloseButton = false, active } = props;
  const dispatch = useDispatch();
  const { size, getNode } = useSize();

  useEffect(() => {
    if (size?.width) dispatch(setPopupWidth(size?.width));
  }, [size?.width, dispatch]);

  const closeHandler = () => {
    onClose && onClose();
  }

  return (<>
    <Fade when={active}>
      <div className={classNames(styles.underlay)} onClick={closeHandler}></div>
    </Fade>
    <Fade when={active}>
      <div className={classNames(styles.window, styles.default)} style={{ height: `${size?.height}px`, width: `${size?.width}px` }}>
        {showCloseButton && <div className={styles.closeButton} onClick={closeHandler}></div>}
        <div ref={getNode} className={styles.content}>{children}</div>
      </div>
    </Fade>
  </>);
}